import React, { Component, createRef } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { pick, omit } from "lodash";

import { Modal, TextInput } from "components";
import { Device } from "utils";

import { styles } from "./styles";

export class FullscreenInput extends Component {
  input = createRef();
  state = { isModalVisible: false };

  render = () => {
    const { component: OriginalComponent, fullscreen, rtl } = this.props;
    const { isModalVisible } = this.state;

    const originalProps = omit(this.props, ["component", "fullscreen"]);

    if (fullscreen === false || !Device.IS_ANDROID_WEB) {
      return <OriginalComponent {...originalProps} />;
    }

    const textInputProps = pick(this.props, [
      "value",
      "maxLength",
      "placeholder",
      "onChangeText",
      "autoCapitalize",
      "secureTextEntry",
    ]);

    return (
      <View>
        <Modal visible={isModalVisible}>
          <View style={styles.container}>
            <TouchableOpacity
              style={styles.doneButton}
              onPress={() => this.setState({ isModalVisible: false })}
            >
              <Text style={styles.doneText}>Done</Text>
            </TouchableOpacity>
            <TextInput
              ref={this.input}
              placeholderTextColor="#c6c6c6"
              style={[styles.text, { textAlign: rtl ? "right" : "left" }]}
              multiline
              type="number"
              {...textInputProps}
            />
          </View>
        </Modal>
        <OriginalComponent
          onFocus={() => {
            this.setState({ isModalVisible: true });
            setTimeout(() => {
              this.input.current.focus();
            }, 100);
          }}
          editable={false}
          {...originalProps}
        />
      </View>
    );
  };
}
